import image from './images/1.jpg'

export const AboutSection: React.FC = () => {
  return (
    <section className="py-20 md:py-28 bg-white px-5">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-medium text-black leading-relaxed">私たち、FLOWERについて</h2>
        <div className="mt-12 aspect-4/3 rounded-xl overflow-hidden">
          <img src={image} alt="FLOWERチーム" className="w-full h-full object-cover" />
        </div>
        <h3 className="mt-8 text-xl md:text-2xl font-medium text-black leading-relaxed">
          累計100万束以上届けてきた
          <br />
          アプリのお花屋さん
        </h3>
        <p className="mt-6 text-[15px] text-main leading-[1.9] max-w-sm mx-auto">
          お花のロス（廃棄）を生み出さない独自の販売の仕組みで、手頃な価格を実現。毎日全国のお客様にたくさんのお花やグリーンをお届けしています。公式Instagramは毎日更新！ぜひこちらもチェックしてみてください。
        </p>
        <a
          href="https://www.instagram.com/flowr_is/"
          target="_blank"
          className="inline-block mt-8 px-8 py-3 border-2 border-black text-black text-[14px] font-medium tracking-wide rounded-full hover:bg-black hover:text-white transition-colors"
        >
          FLOWER公式Instagram
        </a>
      </div>
    </section>
  )
}
